import { getOrDefault } from 'libs/PagingParser'
import * as R from 'ramda'
import { changeTimezone } from 'libs/dateUtils'
import moment from 'moment'
import { createVoucherAttributes } from 'app/main/notification/voucherStartEndTime/VoucherStartEndTimeReducer'

const pickAllTranslated = R.pickAll(['title', 'body', 'description'])

export const createTranslationVoucherPayload = (languageId) => (content) => ({
  languageId: languageId,
  ...pickAllTranslated(content),
})

const getStartDate = (formModel) => {
  return moment(formModel.voucher.startDateTime).utc().format()
}

const getEndDate = (formModel) => {
  return moment(formModel.voucher.endDateTime).utc().format()
}

export const mapVoucherToApi = (formModel) => (translations) => {
  return {
    translations: translations,
    startTime: getOrDefault(null)(() => getStartDate(formModel)),
    endTime: getOrDefault(null)(() => getEndDate(formModel)),
    limitedAmount: getOrDefault(undefined)(() => formModel.limitAmount),
    voucherTemplateId: getOrDefault(undefined)(
      () => formModel.voucherTemplateId,
    ),
  }
}

const getTranslation = R.curry((languageId, translationList) => {
  return R.compose(
    R.defaultTo(R.head(translationList)),
    R.find(R.propEq('languageId', languageId)),
  )(translationList)
})

export const mapBeaconFromApi = {
  id: R.prop('id'),
  titleBodyDescription: (languageId) => {
    return R.compose(
      R.pickAll(['title', 'body', 'description']),
      getTranslation(languageId),
      R.prop('translations'),
    )
  },
  timezone: (notification) => R.prop('timezone', notification),
  limitAmount: (notification) => R.prop('limitedAmount', notification),
  voucher: (notification) =>
    createVoucherAttributes({
      startDateTime: changeTimezone(
        R.prop('startTime', notification),
        R.prop('timezone', notification),
      ),
      endDateTime: changeTimezone(
        R.prop('endTime', notification),
        R.prop('timezone', notification),
      ),
    }),
}
